module.exports = __webpack_public_path__ + "img/Vip_Card_1.81c6a44c.png";